var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"revenue-detail"},[_c('iframe',{staticClass:"iframe1",attrs:{"src":_vm.pageUrl,"id":"iframe1"}})])}
var staticRenderFns = []

export { render, staticRenderFns }